var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
import { Fab, Grid, styled, useMediaQuery } from '@mui/material';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { FIdashboardUrl, FSdashboardUrl, SAdashboardUrl, USER_PROFILE_DATA } from '../../../api/url';
import { AppointmentIcon, CompleteIcon, DeliveredIcon, DotPointsIcon, InProgressIcon, JcOpeneIcon, NewDraftIcon, NewPreJcIcon, PendingIcon, PlusIconWhite, ReadyForInvoiceIcon, ReworkIcon, SearchRefractionIcon, WorkCompletedIcon } from '../../../assets/images';
import { MuiStack } from '../../../components';
import SkeletonLoader from '../../../components/atoms/sketeton';
import ListPageHeaderComponent from '../../../components/templates/listPageHeaderComponent';
import { allOpenStatus, appointmentsStatus, completeStatus, dateBeforeMonth, dateBeforeWeek, deliveredStatus, draftJCStatus, estimateStatus, EUserRole, inProgressStatus, jcOpenedStatus, LOCAL_STORAGE_KEYS, pendingStatus, preJCStatus, readyForInvoiceStatus, reworkStatus, withFIStatus, workCompletedStatus } from '../../../constants';
import { setIsAllViewActive, setIsLeftMenuOpen, showLoader } from '../../../redux/commonSlice';
import { getByIdAPI, resetState } from '../../../redux/crudSlice';
import { useAppSelector } from '../../../store/hooks';
import { systemColor } from '../../../theme/systemColor';
import { getLocalStorageItem, setLocalStorageItem } from '../../../utils/storageHelper';
import useAnalyticsEventTracker from '../../../utils/useAnalyticsEventTracker';
import DashboardCountComponent from './dashboardCountComponent';
import { DashboardTabComponent } from './dashboardTabComponent';
var EStatusType = /*#__PURE__*/ function (EStatusType) {
    EStatusType["Myview"] = "My view";
    EStatusType["AllView"] = "All View";
    return EStatusType;
}(EStatusType || {});
var NextFloatingBtn = styled(Fab)(function (_ref) {
    var theme = _ref.theme;
    return {
        position: 'fixed',
        bottom: 25,
        right: 25
    };
});
var NewDashboard = function () {
    var selectedDesignationStorage = getLocalStorageItem(LOCAL_STORAGE_KEYS.SELECTED_DESIGNATION);
    var selectedDesignation = useAppSelector(function (state) { return state.common; }).selectedDesignation;
    var selectedBranch = getLocalStorageItem(LOCAL_STORAGE_KEYS.SELECTED_BRANCH);
    var userData = getLocalStorageItem(USER_PROFILE_DATA);
    var localFromDate = getLocalStorageItem(LOCAL_STORAGE_KEYS.FILTER_FROM_DATE);
    var localToDate = getLocalStorageItem(LOCAL_STORAGE_KEYS.FILTER_TO_DATE);
    var dispatch = useDispatch();
    var _a = useState([]), dashboardData = _a[0], setDashboardData = _a[1];
    var _b = useAppSelector(function (state) { return state.common; }), isAllViewActive = _b.isAllViewActive, loader = _b.loader;
    var navigate = useNavigate();
    var _c = useState(false), isShowSkeleton = _c[0], setShowSkeleton = _c[1];
    var commonState = useSelector(function (state) { return state.common; });
    var IS_DESKTOP = useMediaQuery(function (theme) { return theme.breakpoints.up("sm"); });
    var lgMode = useMediaQuery('(min-width:600px)');
    var skeletonArray = (selectedDesignationStorage === null || selectedDesignationStorage === void 0 ? void 0 : selectedDesignationStorage.Name) == EUserRole.FinalInspector ? Array.from({
        length: 4
    }) : Array.from({
        length: 10
    });
    var trackButtonClick = useAnalyticsEventTracker("NewDashboard");
    useEffect(function () {
        dispatch(resetState(["getCustomerInfo", "documentDetailsGetById"]));
        dispatch(setIsAllViewActive(false));
        return function () {
            setTimeout(function () {
                dispatch(setIsAllViewActive(false));
            }, 500);
        };
    }, []);
    useEffect(function () {
        var todaysDate = dateFormate(new Date());
        if (selectedDesignationStorage !== null && selectedDesignationStorage !== void 0 && selectedDesignationStorage.Name) {
            var fromDate = localFromDate != null ? dateFormate(localFromDate) : dateFormate((selectedDesignationStorage === null || selectedDesignationStorage === void 0 ? void 0 : selectedDesignationStorage.Name) === EUserRole.FloorSupervisor ? dateBeforeMonth : dateBeforeWeek);
            var toDate = localToDate != null ? dateFormate(localToDate) : todaysDate;
            getSADashboardCountApiCall(fromDate, toDate);
            setLocalStorageItem(LOCAL_STORAGE_KEYS.FILTER_FROM_DATE, fromDate);
            setLocalStorageItem(LOCAL_STORAGE_KEYS.FILTER_TO_DATE, toDate);
        }
    }, [selectedDesignation, selectedDesignationStorage === null || selectedDesignationStorage === void 0 ? void 0 : selectedDesignationStorage.Name, isAllViewActive]);
    var getSADashboardCountApiCall = function (startDate, endDate) { return __awaiter(void 0, void 0, void 0, function () {
        var selectedDesignationDetails, _userData$data, _response, _response2, requestBody, response, _fiterdata, _fiterdata2, fiterdata, updatedFilterData, e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    selectedDesignationDetails = selectedDesignation ? selectedDesignation : selectedDesignationStorage;
                    if (!selectedDesignationDetails) {
                        return [2 /*return*/];
                    }
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 12, , 13]);
                    dispatch(showLoader({
                        isLoaderOpen: true
                    }));
                    setShowSkeleton(true);
                    requestBody = {};
                    requestBody.OrganizationId = selectedBranch === null || selectedBranch === void 0 ? void 0 : selectedBranch.OrganizationId;
                    requestBody.IdentityId = isAllViewActive ? undefined : userData === null || userData === void 0 || (_userData$data = userData.data) === null || _userData$data === void 0 ? void 0 : _userData$data.IdentityId;
                    requestBody.StartDate = new Date(startDate);
                    requestBody.EndDate = new Date(endDate);
                    response = void 0;
                    if (!((selectedDesignationDetails === null || selectedDesignationDetails === void 0 ? void 0 : selectedDesignationDetails.Name) == EUserRole.FinalInspector)) return [3 /*break*/, 3];
                    return [4 /*yield*/, dispatch(getByIdAPI({
                            key: "",
                            url: FIdashboardUrl,
                            request: requestBody
                        }))];
                case 2:
                    response = _a.sent();
                    _a.label = 3;
                case 3:
                    if (!((selectedDesignationDetails === null || selectedDesignationDetails === void 0 ? void 0 : selectedDesignationDetails.Name) == EUserRole.ServiceAdvisor && isAllViewActive)) return [3 /*break*/, 5];
                    return [4 /*yield*/, dispatch(getByIdAPI({
                            key: "",
                            url: SAdashboardUrl,
                            request: requestBody
                        }))];
                case 4:
                    response = _a.sent();
                    _a.label = 5;
                case 5:
                    if (!((selectedDesignationDetails === null || selectedDesignationDetails === void 0 ? void 0 : selectedDesignationDetails.Name) == EUserRole.ServiceAdvisor && !isAllViewActive)) return [3 /*break*/, 7];
                    return [4 /*yield*/, dispatch(getByIdAPI({
                            key: "",
                            url: SAdashboardUrl,
                            request: requestBody
                        }))];
                case 6:
                    response = _a.sent();
                    _a.label = 7;
                case 7:
                    if (!((selectedDesignationDetails === null || selectedDesignationDetails === void 0 ? void 0 : selectedDesignationDetails.Name) == EUserRole.FloorSupervisor && isAllViewActive)) return [3 /*break*/, 9];
                    return [4 /*yield*/, dispatch(getByIdAPI({
                            key: "",
                            url: FSdashboardUrl,
                            request: requestBody
                        }))];
                case 8:
                    response = _a.sent();
                    _a.label = 9;
                case 9:
                    if (!((selectedDesignationDetails === null || selectedDesignationDetails === void 0 ? void 0 : selectedDesignationDetails.Name) == EUserRole.FloorSupervisor && !isAllViewActive)) return [3 /*break*/, 11];
                    return [4 /*yield*/, dispatch(getByIdAPI({
                            key: "",
                            url: FSdashboardUrl,
                            request: requestBody
                        }))];
                case 10:
                    response = _a.sent();
                    _a.label = 11;
                case 11:
                    if ((_response = response) !== null && _response !== void 0 && (_response = _response.payload) !== null && _response !== void 0 && _response.success && ((_response2 = response) === null || _response2 === void 0 || (_response2 = _response2.payload) === null || _response2 === void 0 ? void 0 : _response2.statusCode) == 200) {
                        fiterdata = response.payload.data;
                        fiterdata = (_fiterdata = fiterdata) === null || _fiterdata === void 0 ? void 0 : _fiterdata.map(function (item) {
                            var icon = "";
                            var statusName;
                            switch (item.key) {
                                case 'Appointments':
                                    icon = AppointmentIcon;
                                    statusName = appointmentsStatus;
                                    break;
                                case "Draft JC":
                                    icon = NewDraftIcon;
                                    statusName = draftJCStatus;
                                    break;
                                case "Pre JC":
                                    icon = NewPreJcIcon;
                                    statusName = preJCStatus;
                                    break;
                                case "Estimate":
                                    // icon = NewPreJcIcon;
                                    statusName = estimateStatus;
                                    break;
                                case "JC Opened":
                                    icon = JcOpeneIcon;
                                    statusName = jcOpenedStatus;
                                    break;
                                case "In Progress":
                                    icon = InProgressIcon;
                                    statusName = inProgressStatus;
                                    break;
                                case "Work Completed":
                                    icon = WorkCompletedIcon;
                                    statusName = workCompletedStatus;
                                    break;
                                case "With FI":
                                    icon = SearchRefractionIcon;
                                    statusName = withFIStatus;
                                    break;
                                case "Ready For Invoice":
                                    icon = ReadyForInvoiceIcon;
                                    statusName = readyForInvoiceStatus;
                                    break;
                                case "Delivered":
                                    icon = DeliveredIcon;
                                    statusName = deliveredStatus;
                                    break;
                                case "All Open":
                                    icon = DotPointsIcon;
                                    statusName = allOpenStatus;
                                    break;
                                case "Pending":
                                    icon = PendingIcon;
                                    statusName = pendingStatus;
                                    break;
                                case "Rework":
                                    icon = ReworkIcon;
                                    statusName = reworkStatus;
                                    break;
                                case "Complete":
                                    icon = CompleteIcon;
                                    statusName = completeStatus;
                                    break;
                                default:
                                    icon = JcOpeneIcon;
                                    console.log('unknown tab name...');
                            }
                            return _objectSpread(_objectSpread({}, item), {}, {
                                Icon: icon,
                                StatusName: statusName
                            });
                        });
                        updatedFilterData = (_fiterdata2 = fiterdata) === null || _fiterdata2 === void 0 ? void 0 : _fiterdata2.sort(function (a, b) { return Number(a.sequence) - Number(b.sequence); });
                        setDashboardData(updatedFilterData);
                        dispatch(showLoader({
                            isLoaderOpen: false
                        }));
                        setShowSkeleton(false);
                    }
                    return [3 /*break*/, 13];
                case 12:
                    e_1 = _a.sent();
                    dispatch(showLoader({
                        isLoaderOpen: false
                    }));
                    setShowSkeleton(false);
                    console.log("Error-", e_1);
                    return [3 /*break*/, 13];
                case 13: return [2 /*return*/];
            }
        });
    }); };
    var formateDdMm = function (item) {
        if (item < 10) {
            return "0".concat(item);
        }
        else {
            return item;
        }
    };
    var dateFormate = function (date) {
        var monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
        var objectDate = new Date(date);
        var d = objectDate.getDate();
        var month = monthNames[objectDate.getMonth()];
        var y = objectDate.getFullYear();
        var dd = formateDdMm(d);
        return "".concat(month, " ").concat(dd, ", ").concat(y);
    };
    var onClickFloatingAddButton = function () {
        trackButtonClick("ButtonClickEvent", "Floating_Add_Button", undefined);
        navigate('/create-inspection');
    };
    var onClickDrawerArrow = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            dispatch(setIsLeftMenuOpen(!commonState.isMenuOpen));
            return [2 /*return*/];
        });
    }); };
    return /*#__PURE__*/ React.createElement(React.Fragment, null, selectedDesignationStorage && /*#__PURE__*/ React.createElement(React.Fragment, null, IS_DESKTOP &&
        /*#__PURE__*/
        // (
        //     selectedDesignationStorage?.Name === EUserRole.ServiceAdvisor ||
        //     selectedDesignationStorage?.Name === EUserRole.FloorSupervisor
        // ) &&
        React.createElement(MuiStack, null, /*#__PURE__*/ React.createElement(DashboardTabComponent, {
            sx: {
                width: "100%",
                paddingX: 2
            },
            tabVariant: "standard",
            showTabIndicator: true,
            bgColorApply: true
        })), /*#__PURE__*/ React.createElement(Grid, {
        container: true,
        px: 2,
        mb: 3,
        spacing: 2,
        bgcolor: systemColor.backgroundColor
    }, /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12
    }, /*#__PURE__*/ React.createElement(ListPageHeaderComponent, {
        isFromNewDashboard: true,
        onCalendarFilterApply: function (fromDate, toDate) {
            setLocalStorageItem(LOCAL_STORAGE_KEYS.FILTER_FROM_DATE, fromDate);
            setLocalStorageItem(LOCAL_STORAGE_KEYS.FILTER_TO_DATE, toDate);
            // setLocalStorageItem(LOCAL_STORAGE_KEYS.DASHBOARD_SELECTED_VARIANT, selectedListVariant)
            getSADashboardCountApiCall(fromDate, toDate);
        },
        isDashboard: true
    })), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12
    }, !isShowSkeleton ? /*#__PURE__*/ React.createElement(Grid, {
        container: true,
        spacing: 2,
        alignItems: 'center'
    }, dashboardData === null || dashboardData === void 0 ? void 0 : dashboardData.map(function (itemList) { /*#__PURE__*/ return React.createElement(Grid, {
        item: true,
        xs: 6,
        sm: 4,
        md: 3,
        key: itemList.dashboard_tab,
        alignItems: 'center'
    }, /*#__PURE__*/ React.createElement(DashboardCountComponent, {
        count: itemList.count,
        tabName: itemList.key,
        icon: itemList.Icon,
        statusName: itemList.StatusName,
        displayName: itemList.dashboard_tab
    })); })) : /*#__PURE__*/ React.createElement(Grid, {
        container: true,
        spacing: 2
    }, skeletonArray.map(function (item, index) { /*#__PURE__*/ return React.createElement(Grid, {
        item: true,
        xs: 6,
        sm: 6,
        lg: 3,
        md: 3,
        key: index
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        sx: {
            borderRadius: '4px',
            height: lgMode ? "200px" : '106px',
            width: "100%",
            display: 'flex',
            alignItems: 'center'
        },
        direction: 'column',
        justifyContent: 'center'
    }, /*#__PURE__*/ React.createElement(SkeletonLoader, null))); })))), ((selectedDesignation === null || selectedDesignation === void 0 ? void 0 : selectedDesignation.Name) == "ServiceAdvisor" || (selectedDesignationStorage === null || selectedDesignationStorage === void 0 ? void 0 : selectedDesignationStorage.Name) == EUserRole.ServiceAdvisor) && /*#__PURE__*/ React.createElement(NextFloatingBtn, {
        id: "dashboard-create-jc-fab",
        color: "primary",
        size: "medium",
        onClick: onClickFloatingAddButton
    }, /*#__PURE__*/ React.createElement("img", {
        height: '13.33px',
        width: '13.33px',
        src: PlusIconWhite
    }))));
};
export default NewDashboard;
